import { WagmiAdapter } from "@reown/appkit-adapter-wagmi";
import { createAppKit } from "@reown/appkit/react";
import { bsc, bscTestnet, type AppKitNetwork } from "@reown/appkit/networks";
import { isDevelopment, walletConnectProjectId } from "./env";
console.log("isDevelopment", isDevelopment);
const projectId = walletConnectProjectId || "YOUR_PROJECT_ID";

const chain = isDevelopment ? bscTestnet : bsc;
const networks: [AppKitNetwork, ...AppKitNetwork[]] = [chain];

const metadata = {
  name: "TradingSkill",
  description: "TradingSkill DApp on BSC",
  url:
    typeof window !== "undefined"
      ? window.location.origin
      : "https://tradingskill.ai",
  icons: ["/favicon.ico"],
};

const wagmiAdapter = new WagmiAdapter({
  networks,
  projectId,
});

createAppKit({
  adapters: [wagmiAdapter],
  networks,
  projectId,
  metadata,
  features: {
    analytics: false,
    email: false,
    socials: false,
  },
  themeMode: "dark",
});

export const wagmiConfig = wagmiAdapter.wagmiConfig as any;
